export default function(object) {
  const resultArray = {};
  for (let propertyName in object) {
    resultArray[propertyName] = [];
  }
  return resultArray;
}
